import React from "react";

import CircleEmpty from "../assets/circle_empty.svg";
import CircleFull from "../assets/circle_full.svg";
import CircleHalf from "../assets/circle_half.svg";
import CircleQuarter from "../assets/circle_quarter.svg";
import CircleThreeQuarters from "../assets/circle_three_quarters.svg";
import { FULL, HALF, QUARTER, THREE_QUARTER } from "../constants/constants";

function CircleSkillRepresentation({
	size= 20,
	representationLevel,
}: {
	size?: number;
	representationLevel?: number | string;
}) {
	const ob = {
		width: `${size}px`,
		height: `${size}px`,
		borderRadius: "100%",
	};

	let src;
	let alt = "empty";
	switch (representationLevel) {
		case 1:
		case QUARTER:
			src = CircleQuarter;
			alt = "quarter";
			break;
		case 2:
		case HALF:
			src = CircleHalf;
			alt = "half";
			break;
		case 3:
		case THREE_QUARTER:
			src = CircleThreeQuarters;
			alt = "three-quarter";
			break;
		case 4:
		case FULL:
			src = CircleFull;
			alt = "full";
			break;
		default:
			src = CircleEmpty;
			alt = "empty";
			break;
	}

	return (
		<img style={{ ...ob }} src={src}  alt={alt}/>
	);
}

export default CircleSkillRepresentation;
